import { render, staticRenderFns } from "./uploadsc.vue?vue&type=template&id=d0aa1602&"
import script from "./uploadsc.vue?vue&type=script&lang=js&"
export * from "./uploadsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports